import {
  WSControl,
  WSElement,
  WSForm,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

type Props = {
  /** Verbatim attestation copy (from the tax metadata). */
  attestationText?: string;
  /** RHF field name the consent boolean binds to (the SignatureBlock field key). */
  name: string;
  label: string;
  disabled?: boolean;
};

/**
 * Renders the attestation copy in a plain gray "conditions" box plus a consent
 * checkbox, matching the Sign-and-date design. The checkbox binds to the
 * SignatureBlock field's own key, so its boolean value flows into the submit
 * signature (`consentAccepted`).
 */
export const DynamicFormAttestation: React.FC<Props> = ({
  attestationText,
  name,
  label,
  disabled
}) => (
  <WSList gap="M">
    {attestationText ? (
      <WSElement colorBackground="gray50" p="M">
        <WSText.ParagraphSm color="gray700">
          {attestationText}
        </WSText.ParagraphSm>
      </WSElement>
    ) : null}
    <WSForm.Field
      name={name}
      component={WSControl}
      componentProps={{
        type: "checkbox",
        label:
          label ||
          "I accept the attestation above and certify this submission.",
        size: "S",
        disabled
      }}
    />
  </WSList>
);
